import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { API_BASE } from '../constant';
import { SITE_NAME, buildSeoState, isEntityPath } from '../utils/seo';

const upsertMeta = (key, value, attr = 'name') => {
  if (!value) {
    return;
  }

  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', value);
};

const upsertLink = (rel, href) => {
  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
};

const upsertJsonLd = (id, payload) => {
  let tag = document.head.querySelector(`script[data-seo-id="${id}"]`);
  if (!tag) {
    tag = document.createElement('script');
    tag.type = 'application/ld+json';
    tag.setAttribute('data-seo-id', id);
    document.head.appendChild(tag);
  }
  tag.text = JSON.stringify(payload);
};

const SeoManager = ({ location, veranstaltungenData }) => {
  useEffect(() => {
    // Detail metadata needs the fetched entity. Until the data is in, keep the metadata the
    // (pre-rendered) HTML already carries instead of flashing "nicht gefunden" + noindex.
    if (!(veranstaltungenData || []).length && isEntityPath(location.pathname)) {
      return;
    }

    const seo = buildSeoState(location.pathname, veranstaltungenData || [], API_BASE);

    document.documentElement.lang = 'de';
    document.title = seo.title;

    upsertMeta('description', seo.description);
    upsertMeta('robots', seo.robots);
    upsertMeta('theme-color', '#355fb3');
    upsertMeta('author', SITE_NAME);

    upsertMeta('og:locale', 'de_DE', 'property');
    upsertMeta('og:type', seo.type);
    upsertMeta('og:title', seo.title, 'property');
    upsertMeta('og:description', seo.description, 'property');
    upsertMeta('og:url', seo.canonical, 'property');
    upsertMeta('og:site_name', SITE_NAME, 'property');
    upsertMeta('og:image', seo.image, 'property');
    upsertMeta('og:image:alt', seo.imageAlt, 'property');

    upsertMeta('twitter:card', seo.twitterCard || 'summary');
    upsertMeta('twitter:title', seo.title);
    upsertMeta('twitter:description', seo.description);
    upsertMeta('twitter:image', seo.image);
    upsertMeta('twitter:image:alt', seo.imageAlt);

    upsertLink('canonical', seo.canonical);
    upsertJsonLd('primary', seo.schema);
  }, [location.pathname, veranstaltungenData]);

  return null;
};

export default withRouter(SeoManager);
